import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'delete-tag-modal',
  templateUrl: 'delete-tag-modal.component.html',
  styleUrls: ['../general.scss']
})
export class DeleteTagModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { tagName: string, usedInCount: number },
        public dialogRef: MatDialogRef<DeleteTagModalComponent>
    ) {}

    onDelete(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
